import loadable from '@loadable/component';
export var AsyncPage = loadable(function (_a) {
    var page = _a.page;
    return import("".concat(page));
});
